import React, { useState } from 'react';
import SoftTypography from "components/SoftTypography";
import "./style.css";
import { Card } from '@mui/material';

const TabsComponent = ({ tabsData }) => {
  const [activeTab, setActiveTab] = useState(0);

  // Modify handleChange to prevent interaction with disabled tabs
  const handleChange = (index, disabled) => {
    if (!disabled) {
      setActiveTab(index);
    }
  };

  return (
    <Card
      sx={{
        padding: '20px 40px',
        borderRadius: "12px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        backgroundColor: "#fff",
        marginTop: '40px',
      }}
    >
      <div className="tabs-container">
        <div className="tabs-header">
          {tabsData?.map((tab, index) => (
            <div
              key={index}
              style={{ fontFamily: "inter" }}
              className={`tab ${activeTab === index ? 'tab-active' : ''} ${tab.disabled ? 'tab-disabled' : ''}`} // Add tab-disabled class
              onClick={() => handleChange(index, tab.disabled)}  // Pass the disabled state to handleChange
            >
              {tab.label}
            </div>
          ))}
        </div>
        {tabsData?.map((tab, index) => (
          <div
            key={index}
            className={`tab-content ${activeTab === index ? 'tab-content-active' : ''}`}
          >
            <SoftTypography>{tab.content}</SoftTypography>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default TabsComponent;
